const SHIPPING_DETAILS = "shippingDetails";
const LARGE_APPLIANCES = "LARGE_APPLIANCES";
const LARGE = "LARGE";
const CART_ITEMS_BY_EDD = "cartItemsByEdd";

export default {
  SHIPPING_DETAILS,
  LARGE_APPLIANCES,
  CART_ITEMS_BY_EDD,
  LARGE,
};
